export default __webpack_public_path__ + "static/media/THAIPAIBOON.a6b6be76.png";